import getCurrentBrand from './getCurrentBrand';

function getBrandApiDomain(brand) {
  return process.env.REACT_APP_API_DOMAIN.replace('{brand}', brand);
}

export default function api(path) {
  return `//${getBrandApiDomain(getCurrentBrand())}/api/front-end/v1/${path}`;
};
